'use client';

import { Chip, freddyTheme } from '@coolblue-development/freddy';
import { Energy } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

export const CoolblueEnergyChip = () => {
  const { t } = useTranslation('vacancyDetail.header');
  return (
    <Chip startIcon={<Energy fill={freddyTheme.color.icon.subtle} />}>{t('coolblueEnergy')}</Chip>
  );
};
